import { render, staticRenderFns } from "./ChangeEmailSuccess.vue?vue&type=template&id=2025c2e7&scoped=true"
import script from "./ChangeEmailSuccess.vue?vue&type=script&lang=js"
export * from "./ChangeEmailSuccess.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmailSuccess.vue?vue&type=style&index=0&id=2025c2e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025c2e7",
  null
  
)

export default component.exports